// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__1uuIR","detailsBorder":"styles_detailsBorder__2vbGP"};